import React from 'react';
import ReportDataPage from './ReportDataPage';

const cols = [
  { key: 'consignmentId', header: 'Consignment ID' },
  { key: 'partNumber', header: 'Part number' },
  { key: 'partDescription', header: 'Description' },
  { key: 'result', header: 'Result' },
  { key: 'reason', header: 'Reason' },
  { key: 'quantity', header: 'Qty' },
  {
    key: 'recordedAt',
    header: 'Recorded',
    format: (v) => (v ? new Date(v).toLocaleString() : ''),
  },
];

export default function QCReport() {
  return (
    <ReportDataPage
      title="Quality control report"
      subtitle="QC pass/fail records from receiving and quarantine in ChesiWMS-Lite."
      endpoint="/api/reports/qc-records"
      exportFileSlug="qc-report"
      columns={cols}
      emptyIcon="✅"
    />
  );
}
